export interface ProductMeta {
  metaTitle?: string;
  metaDescription?: string;
  canonicalUrl?: string;
}

export const productMetaFromResponse = (responseData: any): ProductMeta => ({
  metaTitle: responseData.meta_title,
  metaDescription: responseData.meta_description,
  canonicalUrl: responseData.canonical_url,
});
